<template>
    <AxRoadPage :is-loading="isLoading" :title="$t('router.tachograph')">
        <CalendarFilter
            v-model="selectedDate"
            class="tachograph__calendar-filter"
            @input="handleDayClick"
        />
        <TruckTimelineMeasurementFragment
            v-if="asset"
            class="tachograph__measurements"
            :selected-date="selectedDate"
            :driver="driver"
            :tracker="asset"
            :has-title="false"
        />
        <AxRoadDriverTachograph
            v-if="asset"
            :sensor-data="asset.asset_details.sensor_data"
            :show-all-drivers="true"
        />
    </AxRoadPage>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

import AxRoadDriverTachograph from '@/components/ax-road/AxRoadDriverTachograph'
import AxRoadPage from '@/components/ax-road/AxRoadPage'
import CalendarFilter from '@/components/redesigned/CalendarFilter'
import TruckTimelineMeasurementFragment from '@/components/TruckTimelineMeasurementFragment'

export default {
    name: 'TruckDetailsTachographView',
    components: {
        AxRoadDriverTachograph,
        AxRoadPage,
        CalendarFilter,
        TruckTimelineMeasurementFragment,
    },
    data() {
        return {
            isLoading: false,
            asset: null,
            selectedDate: moment().format('YYYY-MM-DD'),
        }
    },
    computed: {
        ...mapGetters('tracker', ['assetsById', 'driversById']),
        driver() {
            return (
                this.driversById[
                    this.asset?.asset_details?.sensor_data?.driver_id?.value
                ] || null
            )
        },
    },
    watch: {
        '$route.params.id': 'fetchTruck',
        '$route.query.date': function(newDate) {
            if (newDate) {
                this.selectedDate = newDate
            }
        },
    },
    created() {
        this.selectedDate =
            this.$route.query.date || moment().format('YYYY-MM-DD')
        this.fetchTruck()
    },
    methods: {
        handleDayClick(day) {
            this.$router.replace({
                name: 'axRoadTruckTachograph',
                params: { id: this.$route.params.id },
                query: { ...this.$route.query, date: day },
            })
        },
        fetchTruck() {
            this.asset = this.assetsById[this.$route.params.id]
        },
    },
}
</script>

<style lang="scss" scoped>
.tachograph {
    &__calendar-filter {
        top: 0;
        position: sticky;
    }
    &__measurements {
        min-height: 15vh;
    }
}
</style>
